"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var wave = (0, _styledComponents.keyframes)(["from{transform:translateX(-100%);}to{transform:translateX(100%);}"]);
var gradientWave = function gradientWave(color) {
  return "linear-gradient(90deg, transparent, ".concat(color, ", transparent)");
};

// Made with template literals because Keyframes don't work with object syntax
var Skeleton = exports.Skeleton = _styledComponents["default"].div.withConfig({
  displayName: "Skeletonstyle__Skeleton",
  componentId: "sc-3tqzhn-0"
})(["border-radius:", "px;background-color:", ";height:", ";text-align:", ";margin-left:", ";margin-right:", ";margin-bottom:", ";width:100%;overflow:hidden;position:relative;&:after{top:0;left:0;right:0;bottom:0;content:'';position:absolute;background:", ";animation:", " 1.6s 0.5s linear infinite;transform:translateX(-100%);}"], function (_ref) {
  var theme = _ref.theme;
  return theme.border.radius['3xs'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.neutral['06'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.inline['2xs'];
}, function (_ref4) {
  var align = _ref4.align;
  return align;
}, function (_ref5) {
  var align = _ref5.align;
  return align === 'center' || align === 'right' ? 'auto' : 0;
}, function (_ref6) {
  var align = _ref6.align;
  return align === 'center' ? 'auto' : 0;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing.inline['4xs'];
}, function (_ref8) {
  var theme = _ref8.theme;
  return gradientWave(theme.color.neutral['07']);
}, wave);